export const CPO_PRODUCT = 2

export const TYPES = {
  REFURBISHED: 'refurbished',
  ACCESSORY: 'accessory',
}
